'use client';

import { Scroll } from '@terra/ui-design-system';
import { VStack } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';

export function HomePageLayout({ children }: { children: ReactNode }) {
  return (
    <Scroll orientation="vertical" showScrollbar h="full">
      <VStack
        gap={4}
        w="full"
        p={6}
        alignItems="stretch"
        flexShrink={0}
        css={{ '& > *': { flexShrink: 0 } }}
      >
        {children}
      </VStack>
    </Scroll>
  );
}
